import React from 'react'
import { Button, type ButtonProps } from '@dostavkee/web-ui'
import clsx from 'clsx'

import styles from './icon-button.module.scss'

interface IconButtonProps extends ButtonProps {
    icon: React.ReactNode
}

export const IconButton = ({ icon, className, ...props }: IconButtonProps) => {
    return <Button {...props} className={clsx(styles['icon-button'], className)} prefixEl={icon} />
}
